import "./App.css";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Homepage from "./pages/HomePage/Homepage";

function App() {
  return (
    <div className="max-w-[2160px] w-full mx-auto">
      <Header />
      <Homepage />
      <Footer />
    </div>
  );
}

export default App;
